/* München Tickets – page concert : plan interactif, filtres et annonces.
   Toutes les données viennent de Shopify (variantes, prix, stock) et des réglages du thème. */
(function () {
  const dataEl = document.getElementById("event-data");
  if (!dataEl) return;
  let D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { console.error("event-data", e); return; }
  const LANG = window.MT_LANG === "en" ? "en" : "de";
  const S = LANG === "en" ? (D.s_en || D.s) : D.s, C = D.cfg, V = D.venue;
  const MT = window.MT || {};
  const $ = id => document.getElementById(id);
  const esc = s => String(s == null ? "" : s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const fill = (tpl, o) => String(tpl || "").replace(/\[(\w+)\]/g, (m, k) => (k in o ? o[k] : m));
  const money = cents => (MT.formatMoney ? MT.formatMoney(cents) : (cents / 100).toFixed(0) + " €");
  const norm = s => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const has = (txt, kw) => !!kw && String(kw).split("|").map(k => k.trim().toLowerCase()).filter(Boolean).some(k => String(txt || "").toLowerCase().indexOf(k) > -1);
  const toast = msg => (MT.toast ? MT.toast(msg) : alert(msg));
  const plural = (n, one, many) => (n > 1 ? many : one);
  const ticketsWord = n => plural(n, (MT.t && MT.t.ticket) || C.ticket, (MT.t && MT.t.tickets) || C.tickets);

  /* ---------------- Géométrie des plans ---------------- */
  function ringSector(cx, cy, rxi, ryi, rxo, ryo, a0, a1) {
    const pt = (rx, ry, a) => { const r = a * Math.PI / 180; return (cx + rx * Math.sin(r)).toFixed(1) + "," + (cy - ry * Math.cos(r)).toFixed(1); };
    const n = Math.max(3, Math.ceil(Math.abs(a1 - a0) / 2)), o = [], i = [];
    for (let k = 0; k <= n; k++) { const a = a0 + (a1 - a0) * k / n; o.push(pt(rxo, ryo, a)); i.unshift(pt(rxi, ryi, a)); }
    return "M" + o.join("L") + "L" + i.join("L") + "Z";
  }
  function midPt(cx, cy, rx, ry, a) { const r = a * Math.PI / 180; return [cx + rx * Math.sin(r), cy - ry * Math.cos(r)]; }
  const splitBar = s => String(s || "").split("|").map(x => x.trim()).filter(Boolean);
  const LI = LANG === "en" ? 1 : 0;
  const pick = s => { const a = String(s || "").split("/").map(x => x.trim()).filter(Boolean); return a[LI] || a[0] || ""; };

  function stadium() {
    const cx = 300, cy = 235, S2 = [];
    const radii = [[172, 124, 210, 158], [215, 163, 244, 189], [249, 194, 286, 224]];
    const rings = String(V.rings || "").split(",").map(x => x.trim()).filter(Boolean).slice(0, 3).map((r, i) => {
      const m = r.match(/^(\d+)\s*-\s*(\d+)(?:\s*@\s*([\d.]+))?$/); if (!m) return null;
      const from = +m[1], to = +m[2], count = to - from + 1;
      return { from, to, c: m[3] ? +m[3] : from + count * 0.86, step: 360 / count, r: radii[i] };
    }).filter(Boolean);
    rings.forEach((R, ri) => {
      for (let n = R.from; n <= R.to; n++) {
        const a = 90 + (R.c - n) * R.step, h = R.step / 2 - .5;
        const m = midPt(cx, cy, (R.r[0] + R.r[2]) / 2, (R.r[1] + R.r[3]) / 2, a);
        S2.push({ key: String(n), d: ringSector(cx, cy, ...R.r, a - h, a + h), lx: m[0], ly: m[1], label: String(n), tier: ri });
      }
    });
    const names = splitBar(V.floorNames), shorts = splitBar(V.floorShort);
    const x0 = cx - 128, w = 206, gap = 2, nz = names.length || 0, zw = nz ? (w - gap * (nz - 1)) / nz : 0;
    const floor = names.map((nm, i) => ({ key: "f" + i, name: pick(nm), alts: nm.split("/").map(x => x.trim()).filter(Boolean), x: x0 + i * (zw + gap), y: cy - 78, w: zw, h: 156, label: pick(shorts[i]) || pick(nm).toUpperCase() }));
    return { vb: "0 0 600 470", S: S2, cx, cy, floor, stage: { x: cx + 84, y: cy - 46, w: 40, h: 92 }, stagePos: { x: cx + 104, y: cy } };
  }
  function arena() {
    const cx = 300, cy = 255, S2 = [];
    const letters = String(V.letters || "ABCDEFGHJKLMNOPQRSTUVW").replace(/[^A-Za-z]/g, "").toUpperCase().split("");
    const count = letters.length * 2, step = 360 / count;
    const ring = (i, r, num, tier) => {
      const a = 272 + i * step, h = step / 2 - .4, m = midPt(cx, cy, (r[0] + r[2]) / 2, (r[1] + r[3]) / 2, a);
      const key = letters[Math.floor(i / 2)] + num;
      S2.push({ key: key.toLowerCase(), d: ringSector(cx, cy, ...r, a - h, a + h), lx: m[0], ly: m[1], label: key, tier });
    };
    const top0 = Math.round(count * 2 / 44), top1 = Math.round(count * 15 / 44);
    for (let i = 0; i < count; i++) {
      ring(i, [178, 138, 218, 173], 1 + i % 2, 0);
      ring(i, [223, 178, 258, 208], 3 + i % 2, 1);
      if (i >= top0 && i <= top1) ring(i, [263, 212, 288, 236], 5 + i % 2, 2);
    }
    const names = splitBar(V.floorNames), shorts = splitBar(V.floorShort);
    const floor = [];
    if (names[0]) floor.push({ key: "f0", name: pick(names[0]), alts: names[0].split("/").map(x => x.trim()), ellipse: { cx: cx + 30, cy, rx: 118, ry: 84 }, label: pick(shorts[0]) || pick(names[0]).toUpperCase() });
    if (names[1]) floor.push({ key: "f1", name: pick(names[1]), alts: names[1].split("/").map(x => x.trim()), ring: ringSector(cx, cy, 291, 239, 301, 248, 22, 158), lx: cx + 296, ly: cy, label: "" });
    return { vb: "-8 0 616 510", S: S2, cx, cy, floor, stage: { x: cx - 152, y: cy - 46, w: 52, h: 92 }, stagePos: { x: cx - 126, y: cy } };
  }
  const G = V.map === "stadium" ? stadium() : V.map === "arena" ? arena() : null;

  /* Sections sans vente */
  const noSaleRanges = String(V.noSale || "").split(",").map(x => x.trim()).filter(Boolean).map(r => { const m = r.match(/^(\w+)\s*-\s*(\w+)$/); return m ? [m[1].toLowerCase(), m[2].toLowerCase()] : [r.toLowerCase(), r.toLowerCase()]; });
  const noSale = k => noSaleRanges.some(([a, b]) => (/^\d+$/.test(a) && /^\d+$/.test(k)) ? (+k >= +a && +k <= +b) : (k === a || k === b));

  /* Index des sections du plan */
  const SEC = {}, FLOOR = {};
  if (G) {
    G.S.forEach(s => { SEC[s.key] = s; });
    G.floor.forEach(f => { (f.alts || [f.name]).forEach(a => { FLOOR[norm(a)] = f.key; }); SEC[f.key] = Object.assign({ floor: true }, f); });
    /* description de position (côté scène, face, latéral) */
    G.S.forEach(s => {
      const a = (Math.atan2(G.stagePos.x - G.cx, G.cy - G.stagePos.y) * 180 / Math.PI + 360) % 360;
      const b = (Math.atan2(s.lx - G.cx, G.cy - s.ly) * 180 / Math.PI + 360) % 360;
      const diff = Math.abs(a - b), off = Math.min(diff, 360 - diff);
      s.off = off; s.north = s.ly < G.cy;
    });
  }
  function mapKey(sec) {
    if (!G) return null;
    const alts = String(sec || "").split("/").map(x => x.trim()).filter(Boolean);
    if (alts.length > 1) { for (const a of alts) { const k = mapKey1(a); if (k) return k; } return null; }
    return mapKey1(sec);
  }
  function mapKey1(sec) {
    const n = norm(sec);
    if (FLOOR[n]) return FLOOR[n];
    if (SEC[n] && !SEC[n].floor) return n;
    const toks = String(sec || "").trim().split(/\s+/), last = norm(toks[toks.length - 1]);
    if (SEC[last] && !SEC[last].floor) return last;
    const p = norm(V.prefix); if (p && n.indexOf(p) === 0 && SEC[n.slice(p.length)]) return n.slice(p.length);
    return null;
  }
  function zoneOf(k) {
    if (!k) return "other";
    const s = SEC[k]; if (!s) return "other";
    if (s.floor) return "floor";
    if (V.map === "stadium") { const t = +String(k)[0]; return t >= 1 && t <= 3 ? "t" + t : "other"; }
    const num = parseInt(String(k).replace(/^[a-z]+/, ""), 10);
    return num <= 2 ? "t1" : "t2";
  }
  ["zFloor", "z1", "z2", "z3"].forEach(k => { V[k] = pick(V[k]); });
  const ZONES = [["all", S.all_label], ["floor", V.zFloor], ["t1", V.z1], ["t2", V.z2]].concat(V.map === "stadium" ? [["t3", V.z3]] : []).filter(z => z[1]);
  const ZC = { floor: "--z-fosse", t1: "--z-1", t2: "--z-2", t3: "--z-3" };
  const secName = k => { const s = SEC[k]; if (!s) return k; if (s.floor) return s.name; return ((V.prefix ? V.prefix + " " : "") + s.label).trim(); };
  function secDesc(k) {
    const s = SEC[k]; if (!s) return "";
    if (s.floor) return S.floor_desc;
    const tiers = V.map === "stadium" ? [V.z1, V.z2, V.z3] : [V.z1, V.z2, V.z3 || V.z2];
    const pos = s.off < 60 ? S.pos_stage : s.off > 130 ? S.pos_face : fill(S.pos_side, { cote: s.north ? S.pos_north : S.pos_south });
    return [tiers[s.tier], pos].filter(Boolean).join(" · ");
  }

  /* ---------------- Annonces ---------------- */
  const ALL = (D.variants || []).map((v, i) => {
    const mk = mapKey(v.s), raw = pick(String(v.s || "").trim());
    const name = /^[A-Za-z]?\d+[A-Za-z]?$/.test(raw) && V.prefix ? V.prefix + " " + raw : raw;
    const row = v.r && v.r !== C.noRow && v.r !== "Default Title" ? pick(v.r) : "";
    const parts = String(v.m || "").split(/\s*[·;,]\s*/).map(x => x.trim()).filter(Boolean).map(x => (/^[!~+*]/.test(x) ? x[0] + pick(x.slice(1)) : pick(x)));
    const ment = parts.filter(x => !/^[!~+*]/.test(x));
    const BC = { "!": "hot", "~": "warm", "+": "good", "*": "info" };
    const bdg = parts.filter(x => /^[!~+*]/.test(x)).map(x => [BC[x[0]], x.slice(1).trim()]).filter(b => b[1]);
    const zone = zoneOf(mk);
    const standing = zone === "floor" || ment.some(m => has(m, C.kwStanding));
    return { i, id: v.id, name, row, ment, bdg, price: v.p, avail: !!v.a, q: v.q, map: mk, zone, standing };
  });
  /* Sections forcées « Complet » (tag complet:101,102) */
  const FORCED = new Set(String(D.forcedSold || "").split(/[,;\/]+/).map(x => x.trim()).filter(Boolean).map(x => mapKey(x) || norm(x)));
  ALL.forEach(o => { if (o.map && FORCED.has(o.map)) o.avail = false; });
  const AV = ALL.filter(o => o.avail);
  const stats = {};
  AV.forEach(o => { if (!o.map) return; const s = stats[o.map] || (stats[o.map] = { n: 0, min: Infinity }); s.n++; s.min = Math.min(s.min, o.price); });
  const minAll = AV.length ? Math.min(...AV.map(o => o.price)) : 0, maxAll = AV.length ? Math.max(...AV.map(o => o.price)) : 0;

  let qty = Math.min(C.qty || 2, C.max || 4), together = true, zone = "all", sel = null, sort = "rec", shown = C.pageSize || 20, maxP = maxAll;
  const enough = o => o.q === null || o.q === undefined || o.q >= qty;
  const placement = o => qty < 2 ? "" : o.standing ? S.p_standing : together ? S.p_together : S.p_free;
  const secState = k => stats[k] ? "av" : (noSale(k) ? "na" : "so");

  /* ---------------- Rendu du plan ---------------- */
  const map = $("map"), tip = $("mtip");
  function mapSVG() {
    if (!G) return "";
    let s = '<svg viewBox="' + G.vb + '" role="img" aria-label="' + esc(D.venueName) + '"><defs><pattern id="hatch" width="5" height="5" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="5" height="5" style="fill:var(--sold)"></rect><line x1="0" y1="0" x2="0" y2="5" style="stroke:var(--sold-line)" stroke-width="2"></line></pattern></defs>';
    G.S.forEach(x => {
      const st = secState(x.key);
      s += '<path class="sec ' + st + ' z-' + zoneOf(x.key) + '" data-key="' + x.key + '" d="' + x.d + '"></path>';
      if (x.label) s += '<text class="num ' + (st === "av" ? "" : st) + '" x="' + x.lx.toFixed(1) + '" y="' + x.ly.toFixed(1) + '">' + esc(x.label) + '</text>';
    });
    G.floor.forEach(z => {
      const st = secState(z.key), price = st === "av" ? money(stats[z.key].min) : esc(S.tt_sold);
      if (z.ellipse) {
        const f = z.ellipse;
        s += '<ellipse class="sec ' + st + ' z-floor" data-key="' + z.key + '" cx="' + f.cx + '" cy="' + f.cy + '" rx="' + f.rx + '" ry="' + f.ry + '"></ellipse>';
        s += '<text class="zl' + (st === "av" ? "" : " so") + '" x="' + f.cx + '" y="' + (f.cy - 4) + '">' + esc(z.label) + '</text>';
        s += '<text class="zp' + (st === "av" ? "" : " so") + '" x="' + f.cx + '" y="' + (f.cy + 14) + '">' + price + '</text>';
      } else if (z.ring) {
        s += '<path class="sec ' + st + ' z-floor" data-key="' + z.key + '" d="' + z.ring + '"></path>';
      } else {
        s += '<rect class="sec ' + st + ' z-floor" data-key="' + z.key + '" x="' + z.x.toFixed(1) + '" y="' + z.y + '" width="' + z.w.toFixed(1) + '" height="' + z.h + '" rx="4"></rect>';
        s += '<text class="zl' + (st === "av" ? "" : " so") + '" x="' + (z.x + z.w / 2).toFixed(1) + '" y="' + (z.y + z.h / 2 - 6) + '">' + esc(z.label) + '</text>';
        s += '<text class="zp' + (st === "av" ? "" : " so") + '" x="' + (z.x + z.w / 2).toFixed(1) + '" y="' + (z.y + z.h / 2 + 10) + '">' + price + '</text>';
      }
    });
    const st = G.stage;
    s += '<rect class="stg" x="' + st.x + '" y="' + st.y + '" width="' + st.w + '" height="' + st.h + '" rx="3"/>';
    s += '<text class="stg-t" transform="translate(' + (st.x + st.w / 2 + 4) + ',' + (st.y + st.h / 2) + ') rotate(-90)">' + esc(pick(V.stage)) + '</text>';
    return s + '</svg>';
  }
  if (G) {
    map.insertAdjacentHTML("afterbegin", mapSVG());
    const centerMap = () => { if (map.scrollWidth > map.clientWidth) map.scrollLeft = (map.scrollWidth - map.clientWidth) / 2; };
    requestAnimationFrame(centerMap); setTimeout(centerMap, 150); window.addEventListener("load", centerMap);
    const legend = ZONES.filter(z => z[0] !== "all").map(z => '<span><i style="background:var(' + ZC[z[0]] + ')"></i>' + esc(z[1]) + '</span>').join("") +
      '<span><i style="background:repeating-linear-gradient(45deg,var(--sold) 0 2px,var(--sold-line) 2px 4px)"></i>' + esc(S.legend_sold) + '</span>' +
      (noSaleRanges.length ? '<span><i style="background:var(--blocked)"></i>' + esc(S.legend_nosale) + '</span>' : '');
    $("legend").innerHTML = legend;
    const nSold = map.querySelectorAll(".sec.so").length, sc = document.querySelector(".socount");
    if (sc && nSold > 0) { document.querySelectorAll(".socount").forEach(x => { x.textContent = nSold; }); sc.closest("[data-soldout-wrap]").hidden = false; }
  } else {
    const mp = document.querySelector("[data-map-panel]"); if (mp) mp.remove();
    const grid = document.querySelector(".ev-grid"); if (grid) grid.style.gridTemplateColumns = "minmax(0,1fr)";
  }

  function tipHTML(k) {
    const st = secState(k);
    let h = '<b>' + esc(secName(k)) + '</b><div class="s">' + esc(secDesc(k)) + '</div>';
    if (st === "na") return h + '<div class="so">' + esc(S.tt_nosale) + '</div>';
    if (st === "so") return h + '<div class="so">' + esc(S.tt_sold) + '</div>';
    const ls = AV.filter(o => o.map === k), rows = ls.map(o => parseInt(o.row, 10)).filter(x => !isNaN(x)), inB = ls.filter(o => o.price <= maxP && enough(o));
    if (rows.length) { const a = Math.min(...rows), b = Math.max(...rows); h += '<div class="s">' + esc(a === b ? fill(S.tt_row, { a }) : fill(S.tt_rows, { a, b })) + '</div>'; }
    else if (SEC[k] && SEC[k].floor) h += '<div class="s">' + esc(S.tt_standing) + '</div>';
    if (!inB.length) return h + '<div class="p">' + esc(fill(S.tt_none_under, { prix: money(maxP) })) + '</div>';
    return h + '<div class="p">' + fill(esc(S.tt_listings), { n: inB.length, annonces: plural(inB.length, S.one, S.many), prix: '<strong>' + money(Math.min(...inB.map(o => o.price))) + '</strong>' }) + '</div>';
  }
  if (G) {
    map.addEventListener("pointermove", e => {
      if (e.pointerType === "touch") return;
      const t = e.target.closest(".sec"); if (!t) { tip.hidden = true; return; }
      tip.innerHTML = tipHTML(t.dataset.key); tip.hidden = false;
      const r = map.getBoundingClientRect();
      let x = e.clientX - r.left + 14, y = e.clientY - r.top + 14;
      if (x + tip.offsetWidth > r.width) x = e.clientX - r.left - tip.offsetWidth - 14;
      if (y + tip.offsetHeight > r.height) y = e.clientY - r.top - tip.offsetHeight - 14;
      tip.style.left = Math.max(0, x) + "px"; tip.style.top = Math.max(0, y) + "px";
    });
    map.addEventListener("pointerleave", () => { tip.hidden = true; });
  }

  /* ---------------- Liste ---------------- */
  function featList(o) {
    const li = [], tw = ticketsWord(qty);
    const tpl = qty > 1 && !o.standing ? (together ? S.f_tickets_together : S.f_tickets_free) : S.f_tickets;
    li.push('<li>' + esc(fill(tpl, { n: qty, billets: tw })) + '</li>');
    o.ment.forEach(m => {
      if (o.standing && has(m, C.kwStanding)) { li.push('<li>' + esc(m) + '</li>'); return; }
      const cls = has(m, C.kwLimited) ? "lim" : has(m, C.kwGood) ? "good" : "";
      li.push('<li' + (cls ? ' class="' + cls + '"' : '') + '>' + esc(m) + '</li>');
    });
    return '<ul>' + li.join("") + '</ul>';
  }
  function badges(o) {
    const out = [];
    if (o.price === minAll && S.b_best) out.push(["best", S.b_best]);
    if (o.bdg.length) {
      o.bdg.forEach(b => out.push(b));
      return '<div class="tags">' + out.slice(0, C.badgeMax || 1).map(b => '<span class="tag ' + b[0] + '">' + esc(b[1]) + '</span>').join("") + '</div>';
    }
    if (!C.badgeAuto) return out.length ? '<div class="tags">' + out.map(b => '<span class="tag ' + b[0] + '">' + esc(b[1]) + '</span>').join("") + '</div>' : '';
    const isLast = o.q !== null && o.q !== undefined && C.lastStock > 0 && o.q <= C.lastStock;
    if (!isLast && o.q !== null && o.q !== undefined && C.lowStock > 0 && o.q <= C.lowStock && S.b_low) out.push(["hot", fill(S.b_low, { n: o.q })]);
    if (o.map && stats[o.map] && stats[o.map].n === 1 && o.i % 3 === 0 && S.b_last_section) out.push(["hot", S.b_last_section]);
    if (isLast && S.b_last) out.push(["hot", S.b_last]);
    return out.length ? '<div class="tags">' + out.slice(0, C.badgeMax || 1).map(b => '<span class="tag ' + b[0] + '">' + esc(b[1]) + '</span>').join("") + '</div>' : '';
  }
  function list() {
    let r = AV.filter(o => (zone === "all" || o.zone === zone) && (!sel || o.map === sel) && o.price <= maxP && enough(o));
    if (sort === "asc") r = [...r].sort((a, b) => a.price - b.price);
    if (sort === "desc") r = [...r].sort((a, b) => b.price - a.price);
    return r;
  }
  const zmin = z => { const p = AV.filter(o => (z === "all" || o.zone === z) && enough(o)).map(o => o.price); return p.length ? Math.min(...p) : null; };
  const prange = $("prange");
  prange.min = minAll; prange.max = maxAll; prange.value = maxAll; prange.step = 100;
  $("pmin").textContent = money(minAll); $("pmax").textContent = money(maxAll);
  if (minAll === maxAll) prange.disabled = true;

  function draw() {
    const r = list(), max = C.max || 4;
    $("count").textContent = r.length + " " + plural(r.length, S.one, S.many);
    $("qpills").innerHTML = Array.from({ length: max }, (_, i) => i + 1).map(n => '<button type="button" data-n="' + n + '" aria-pressed="' + (n === qty) + '">' + n + '</button>').join("");
    const tg = $("togbtn"); tg.setAttribute("aria-checked", String(together && qty > 1)); tg.disabled = qty < 2;
    $("pval").textContent = maxP >= maxAll ? S.price_all : fill(S.price_upto, { prix: money(maxP) });
    $("chips").innerHTML = ZONES.map(z => {
      if (z[0] !== "all" && !AV.some(o => o.zone === z[0]) && !ALL.some(o => o.zone === z[0])) return "";
      const m = zmin(z[0]), dot = z[0] !== "all" ? '<i style="background:var(' + ZC[z[0]] + ')"></i>' : '';
      if (m === null && !AV.some(o => z[0] === "all" || o.zone === z[0])) return '<button class="cat2 sold" type="button" disabled>' + dot + '<span>' + esc(z[1]) + '</span><small>' + esc(S.sold_out_chip) + '</small></button>';
      if (m === null) return '<button class="cat2" type="button" data-zone="' + z[0] + '" aria-pressed="' + (zone === z[0] && !sel) + '">' + dot + '<span>' + esc(z[1]) + '</span><small>–</small></button>';
      return '<button class="cat2" type="button" data-zone="' + z[0] + '" aria-pressed="' + (zone === z[0] && !sel) + '">' + dot + '<span>' + esc(z[1]) + '</span><small>' + esc(S.from) + ' ' + money(m) + '</small></button>';
    }).join("") + (sel ? '<button class="cat2 sel" type="button" data-clear="1"><span>' + esc(secName(sel)) + '</span><small>✕</small></button>' : '');
    if (G) {
      map.querySelectorAll(".sec.av").forEach(p => {
        const k = p.dataset.key, ok = AV.some(o => o.map === k && o.price <= maxP && enough(o));
        p.classList.toggle("off", !ok);
        const n = p.nextElementSibling; if (n && n.classList.contains("num")) n.classList.toggle("off", !ok);
        p.classList.toggle("on", k === sel);
      });
      map.classList.toggle("has-sel", !!sel);
    }
    $("lst").innerHTML = r.length ? r.slice(0, shown).map(o =>
      '<div class="item" role="button" tabindex="0" data-i="' + o.i + '"><div><div class="nm">' + esc(o.name) + '</div>' + (o.row ? '<div class="row">' + esc(S.row) + ' ' + esc(o.row) + '</div>' : '') + featList(o) + badges(o) + '</div>' +
      '<div class="pr"><b>' + money(o.price) + '</b><small>' + esc(S.per_ticket) + '</small><small class="tot">' + esc(fill(S.total_for, { prix: money(o.price * qty), n: qty })) + '</small><button class="addq" type="button" data-add="' + o.i + '">' + esc(S.add) + '</button></div></div>').join("")
      : '<div class="empty" style="margin:14px">' + esc(S.empty) + '</div>';
    const ps = C.pageSize || 20;
    $("more").innerHTML = r.length > shown ? '<button class="btn ghost" id="morebtn" type="button">' + esc(fill(S.more, { n: Math.min(ps, r.length - shown) })) + '</button>' : (r.length ? '<small style="color:var(--muted)">' + esc(fill(S.of, { n: r.length, total: r.length })) + '</small>' : '');
    const mb = $("morebtn"); if (mb) mb.onclick = () => { shown += ps; draw(); };
    $("selhead").innerHTML = sel ? '<div class="selbar"><i style="background:var(' + (ZC[zoneOf(sel)] || "--seat") + ')"></i><div class="t"><b>' + esc(secName(sel)) + '</b><span>' + esc(secDesc(sel)) + ' · ' + r.length + ' ' + esc(plural(r.length, S.one, S.many)) + '</span></div><button type="button" data-unsel="1">' + esc(S.unsel) + '</button></div>' : '';
  }

  if (G) map.addEventListener("click", e => {
    if (e.target.closest(".sec.so")) { toast(S.toast_sold); return; }
    const t = e.target.closest(".sec.av"); if (!t) return;
    if (t.classList.contains("off")) { toast(fill(S.toast_budget, { prix: money(maxP) })); return; }
    sel = sel === t.dataset.key ? null : t.dataset.key; zone = "all"; shown = C.pageSize || 20; draw();
    tip.hidden = true;
    const sh = $("selhead"), b = sh.getBoundingClientRect();
    if (sel && (b.top < 80 || b.top > innerHeight - 220)) sh.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
  });
  $("chips").addEventListener("click", e => { const b = e.target.closest(".cat2:not(.sold)"); if (!b) return; if (b.dataset.clear) sel = null; else { zone = b.dataset.zone; sel = null; } shown = C.pageSize || 20; draw(); });
  $("sort").addEventListener("change", e => { sort = e.target.value; draw(); });
  $("qpills").addEventListener("click", e => { const b = e.target.closest("button"); if (!b) return; qty = +b.dataset.n; draw(); });
  $("togbtn").addEventListener("click", () => { together = !together; draw(); });
  prange.addEventListener("input", e => { maxP = +e.target.value; if (+e.target.value >= maxAll - 100) maxP = maxAll; tip.hidden = true; if (sel && stats[sel] && stats[sel].min > maxP) sel = null; shown = C.pageSize || 20; draw(); });
  $("reset").addEventListener("click", () => { zone = "all"; sel = null; sort = "rec"; maxP = maxAll; shown = C.pageSize || 20; prange.value = maxAll; $("sort").value = "rec"; draw(); });
  const lst = $("lst");
  lst.addEventListener("click", e => {
    const q = e.target.closest(".addq"); if (q) { e.stopPropagation(); addToCart(ALL[+q.dataset.add]); return; }
    const b = e.target.closest(".item"); if (b) openOrder(ALL[+b.dataset.i]);
  });
  lst.addEventListener("keydown", e => { const b = e.target.closest(".item"); if (b && e.target === b && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); openOrder(ALL[+b.dataset.i]); } });
  $("selhead").addEventListener("click", e => { if (e.target.closest("[data-unsel]")) { sel = null; shown = C.pageSize || 20; draw(); } });

  /* ---------------- Fenêtres ---------------- */
  const qm = $("qmodal"), om = $("omodal");
  let pending = qty;
  function openQty() {
    pending = qty;
    $("qgrid").innerHTML = Array.from({ length: C.max || 4 }, (_, i) => i + 1).map(n => '<button type="button" data-n="' + n + '" aria-pressed="' + (n === pending) + '">' + n + '</button>').join("");
    qm.hidden = false; $("qok").focus();
  }
  $("qgrid").addEventListener("click", e => { const b = e.target.closest("button"); if (!b) return; pending = +b.dataset.n; $("qgrid").querySelectorAll("button").forEach(x => x.setAttribute("aria-pressed", x === b ? "true" : "false")); });
  $("qok").addEventListener("click", () => { qty = pending; qm.hidden = true; draw(); });

  let current = null;
  function openOrder(o) {
    current = o;
    const pl = placement(o);
    const row = (a, b, cls) => '<div class="l' + (cls ? " " + cls : "") + '"><span>' + esc(a) + '</span><span>' + b + '</span></div>';
    $("oticket").innerHTML =
      row(S.om_concert, esc(D.title)) + row(S.om_date, esc(String(LANG === "en" ? D.dateEn : D.date).replace(/\s*·\s*$/, ""))) + row(S.om_venue, esc(D.venueName)) +
      row(S.om_place, esc(o.name + (o.row ? ", " + S.row.toLowerCase() + " " + o.row : ""))) +
      row(S.om_tickets, qty + " × " + money(o.price)) + (pl ? row(S.om_placement, esc(pl)) : "") +
      row(S.om_total, money(o.price * qty), "tot");
    om.hidden = false; $("oadd").focus();
  }
  $("oadd").addEventListener("click", () => { if (current) addToCart(current); });
  $("ocancel").addEventListener("click", () => { om.hidden = true; });
  [qm, om].forEach(m => m.addEventListener("click", e => { if (e.target === m) { m.hidden = true; if (m === qm) draw(); } }));
  document.addEventListener("keydown", e => { if (e.key === "Escape") { qm.hidden = true; om.hidden = true; } });

  /* ---------------- Panier ---------------- */
  async function addToCart(o) {
    if (!enough(o)) { toast(S.toast_stock); return; }
    const max = C.max || 4;
    let inCart = 0;
    try { inCart = MT.getCart ? (await MT.getCart()).item_count : 0; } catch (e) {}
    if (inCart + qty > max) {
      om.hidden = true;
      toast(inCart >= max ? fill(MT.t.maxReached, { max }) : fill(MT.t.maxLeft, { max, n: max - inCart }));
      MT.openCart && MT.openCart(true);
      return;
    }
    const pl = placement(o), props = { _title_de: D.title + " – " + String(D.date).replace(/\s*·\s*$/, ""), _title_en: D.title + " – " + String(D.dateEn || D.date).replace(/\s*·\s*$/, "") };
    if (pl && C.placementLabel) props[C.placementLabel] = pl;
    try {
      const res = await fetch(MT.routes.cartAdd, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: o.id, quantity: qty, properties: props }] }) });
      const j = await res.json();
      if (!res.ok) { toast(j.description || j.message || MT.t.error); return; }
      om.hidden = true;
      MT.onAdded && MT.onAdded();
      toast(fill(MT.t.added, { n: qty, billets: ticketsWord(qty) }));
    } catch (e) { toast(MT.t.error); }
  }

  draw();
  if (S.qm_show && AV.length) openQty();
})();
